import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CASH,
  COMPLETION_PERIOD,
  EXERCISE_PERIOD,
  TEMPORARY_EXTENSION_OF_STAY,
  CPF_OA_PER_CASH,
  DEFAULT_LOAN_DETAILS_AGE_65,
  LEGAL_FEE,
  LOAN_AMOUNT,
  MORTGAGE_INTEREST_RATE,
  OPTION_EXERCISE_FEE,
  OPTION_FEE,
  PricingMode,
} from '@/constants/private-resale/purchase-resale';
import { ABSD, PAGE } from '@/constants/common';
import { FormTypes } from '.';

interface ResaleState {
  formField: FormTypes;
  loading: boolean;
  from: PAGE | '';
}

export const initialState: ResaleState = {
  formField: {
    loanType: DEFAULT_LOAN_DETAILS_AGE_65.AGE,
    isCheckedMonthlyPayable: true,
    purchasePrice: '',
    valuationPrice: '',
    optionFee: OPTION_FEE.DEFAULT.toString(),
    optionFeeAmount: '0',
    optionExerciseFee: OPTION_EXERCISE_FEE.DEFAULT.toString(),
    optionExerciseFeeAmount: '0',
    absd: ABSD.LIST[0].value,
    legalFees: LEGAL_FEE.DEFAULT.toString(),
    loanTenure: DEFAULT_LOAN_DETAILS_AGE_65.LOAN_TENURE.toString(),
    mortgageInterestRate: MORTGAGE_INTEREST_RATE.DEFAULT.toString(),
    loanToValue: DEFAULT_LOAN_DETAILS_AGE_65.LOAN_TO_VALUE_DEFAULT.toString(),
    exercisePeriod: EXERCISE_PERIOD.DEFAULT,
    completionPeriod: COMPLETION_PERIOD.DEFAULT,
    temporaryExtensionOfStay: TEMPORARY_EXTENSION_OF_STAY.DEFAULT.toString(),
    cash: CASH.DEFAULT,
    cPFoAPerCash: CPF_OA_PER_CASH.DEFAULT,
    otpDate: new Date().toString(),
    loanAmount: LOAN_AMOUNT.DEFAULT,
    pricingMode: PricingMode.BY_PERCENTAGE,
  },
  loading: true,
  from: '' as PAGE | '',
};

export const purchaseResaleSlice = createSlice({
  name: 'resale',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: () => {},
});

export const { updateDataForm, updateFrom, reset } = purchaseResaleSlice.actions;

export default purchaseResaleSlice.reducer;
